import styled from 'styled-components'

const Box = styled.div`
  position: relative;
  min-height: 32px;
  border-radius: 24px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid transparent;
  background: ${({ theme }) => theme.colors.input};
  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.03);
  transition: border-color 200ms ease, background 200ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const ActiveBoxContainer = styled(Box)`
  border-color: ${({ theme }) => theme.colors.cardBorder};
`

const EBoxSm = ({ children, isActive = false, ...rest }) => {
  if (isActive) {
    return <ActiveBoxContainer {...rest}>{children}</ActiveBoxContainer>
  }

  return <Box {...rest}>{children}</Box>
}

export default EBoxSm
